<script lang="ts">
import {Modal} from "bootstrap";
import {defineComponent, ref} from "vue";
import {storeToRefs} from "pinia";
import {useEventStore} from "@/composables/events";
import {useLayoutsStore} from "@/composables/layouts";
import EventCard from "@/components/cards/EventCard.vue";
import {IRequestCar} from "@/interfaces/IRequestCar";

export default defineComponent({
  name: 'EventsView',
  // eslint-disable-next-line no-unused-vars
  setup(props, emits) {
    const layoutStore = useLayoutsStore();
    const statuses: Array<{name: String, status: String | null}> = ([{
      name: 'Все',
      status: null,
    }, {
      name: 'Ожидает',
      status: 'wait'
    }, {
      name: 'Согласовано',
      status: 'agree'
    }, {
      name: 'Отказано',
      status: 'disagree'
    }]);

    const eventStore = useEventStore();
    const {events, paginate, filters} = storeToRefs(eventStore);
    const getStatusRequest = eventStore.getStatusRequest;

    // Поиск событий
    const searchEvents = async () => {
      layoutStore.changeLayout('loader');
      await eventStore.loadEvents();
      layoutStore.changeLayout('layout');
    };

    const next = async (page: Number) => {
      filters.value.page = page;
      layoutStore.changeLayout('loader');
      await searchEvents();
      layoutStore.changeLayout('layout');
    };

    const selectedEvent = ref<IRequestCar | undefined>(undefined);
    const onSelectEvent = (id: number) => {
      selectedEvent.value = events.value.find((e: IRequestCar) => e.id === id);

      const element: Element | null = document.getElementById('routeModal');
      if (element) {
        const modal = Modal.getOrCreateInstance(element, {
          backdrop: 'static',
          keyboard: true,
          focus: true
        });
        modal.show();
      }
    };

    return {
      events,
      filters,
      statuses,
      paginate,
      getStatusRequest,
      searchEvents,
      onSelectEvent,
      selectedEvent,
      next,
    };
  },
  components: {
    EventCard,
  },
  async beforeRouteEnter(to, from, next) {
    const layout = useLayoutsStore();
    const { layoutTypes } = storeToRefs(layout);
    const { changeLayout } = useLayoutsStore();

    changeLayout(layoutTypes.value.loader);

    const eventStore = useEventStore();
    await eventStore.loadEvents();

    changeLayout(layoutTypes.value.layout);

    next(true);
  }
})
</script>

<template>
  <div class="container my-2">
    <div class="row">
      <div class="col-lg-12">
        <div class="row row-cols-1 g-4 mb-4">
          <div class="col">
            <div class="row">
              <div class="col-10 offset-2">
                <div class="form-group d-flex align-items-center gap-2">
                  <label class="w-100">
                    Номер запроса
                    <input v-model="filters.id" type="number" class="form-control form-control-sm w-100">
                  </label>

                  <label class="w-100">
                    Статус
                    <select v-model="filters.status" class="form-control form-control-sm w-100">
                      <option v-for="(status, i) in statuses" :key="i" :value="status.status">
                        {{ status.name }}
                      </option>
                    </select>
                  </label>

                  <div class="d-flex h-100">
                    <button @click="searchEvents()" class="btn btn-sm btn-primary mt-auto" style="margin-top: 25px !important;">
                      <i class="bi bi-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <template v-if="paginate.count">
              <EventCard
                  v-for="(event, i) in events"
                  :key="i"
                  :event="event"
                  :statusFormat="getStatusRequest"
                  @event:openRouteModal="onSelectEvent"
              />
            </template>

            <template v-else>
              <div class="d-flex justify-content-center align-items-center" style="min-height: max-content">
                <span class="fw-bold">Список заявок пуст</span>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="fixed-bottom bg-white d-flex gap-2 align-items-center py-2 px-2">
          <button
              :disabled="(paginate.pages[0] === paginate.page) || !paginate.count"
              @click="next(!paginate.page ? paginate.page : paginate.page - 1)"
              class="btn btn-sm btn-primary"
          >
            <i class="bi bi-arrow-left-square"></i>
          </button>
          <button
              :disabled="(paginate.pages[paginate.pages.length - 1] === paginate.page) || !paginate.count"
              @click="next(paginate.page + 1)"
              class="btn btn-sm btn-primary"
          >
            <i class="bi bi-arrow-right-square"></i>
          </button>

          <span class="text-secondary">
            Текущая страница: {{ paginate.page + 1 }}
          </span>
        </div>
      </div>
    </div>

    <div class="modal fade" id="routeModal" aria-hidden="true" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ selectedEvent ? `#${selectedEvent.id}` : 'Запрос не найден' }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <template v-if="selectedEvent">
              <ul v-for="(technic, i) in selectedEvent.technics" :key="i" class="list-unstyled">
                <template v-for="(tread, j) in technic.treads" :key="j">
                  <template v-for="(task, k) in tread.tasks" :key="k">
                    <li v-if="task.geo_task_type === 10">
                      {{ task.geo_tasks_name }}
                    </li>
                  </template>
                </template>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
